import { render } from "./messaging-service-configuration-form-message-detail-section.vue?vue&type=template&id=310eff8c&ts=true"
import script from "./messaging-service-configuration-form-message-detail-section.vue?vue&type=script&lang=ts"
export * from "./messaging-service-configuration-form-message-detail-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__